(() => {
  if (window.GhostlyBundleSimpleLoaded) return;
  window.GhostlyBundleSimpleLoaded = true;

  const bundleDetailsSelector =
    'details[is="product-bundle-details"][form]';

  function getBundleDetails(formId) {
    return Array.from(
      document.querySelectorAll(bundleDetailsSelector)
    ).filter(
      details => details.getAttribute('form') === formId
    );
  }

  function getCheckedBundles(formId) {
    return getBundleDetails(formId).flatMap(details =>
      Array.from(
        details.querySelectorAll(
          'input[name="bundles"]:checked:not(:disabled)'
        )
      )
    );
  }

  async function addBundle(form, event) {
    const formId = form.getAttribute('id');

    const checkedBundles =
      getCheckedBundles(formId);

    console.log(
      '[Ghostly Bundle] form:',
      formId
    );

    console.log(
      '[Ghostly Bundle] checked:',
      checkedBundles
    );

    // No bundle selected:
    // let the theme's normal Add to Cart continue.
    if (!checkedBundles.length) {
      return;
    }

    // Stop the native ProductForm handler
    // so the main product is not added twice.
    event.preventDefault();
    event.stopImmediatePropagation();

    const formData = new FormData(form);

    const mainVariantId =
      formData.get('id');

    if (!mainVariantId) {
      console.error(
        '[Ghostly Bundle] Main variant ID missing'
      );
      return;
    }

    const quantity =
      parseInt(
        formData.get('quantity') || '1',
        10
      );

    const mainItem = {
      id: Number(mainVariantId),

      quantity:
        Number.isFinite(quantity) &&
        quantity > 0
          ? quantity
          : 1
    };

    /*
     * Preserve product properties
     */
    const properties = {};

    for (const [key, value] of formData.entries()) {
      const match =
        key.match(/^properties\[(.+)\]$/);

      if (
        match &&
        value !== ''
      ) {
        properties[match[1]] =
          value;
      }
    }

    if (
      Object.keys(properties).length
    ) {
      mainItem.properties =
        properties;
    }

    /*
     * Preserve selling plan
     */
    const sellingPlan =
      formData.get('selling_plan');

    if (sellingPlan) {
      mainItem.selling_plan =
        Number(sellingPlan);
    }

    /*
     * Bundle items
     */
    const bundleItems =
      checkedBundles.map(input => {
        const min =
          parseInt(
            input.dataset.min || '1',
            10
          );

        return {
          id: Number(input.value),

          quantity:
            Number.isFinite(min) &&
            min > 0
              ? min
              : 1
        };
      });

    const items = [
      mainItem,
      ...bundleItems
    ];

    console.log(
      '[Ghostly Bundle] Sending:',
      items
    );

    const submitButtons =
      Array.from(form.elements)
        .filter(
          el => el.type === 'submit'
        );

    submitButtons.forEach(button => {
      button.setAttribute(
        'aria-busy',
        'true'
      );
    });

    document.documentElement.dispatchEvent(
      new CustomEvent(
        'theme:loading:start',
        {
          bubbles: true
        }
      )
    );

    try {
      /*
       * Ask Ghostly Engines which cart
       * sections need refreshing
       */
      const sectionsToBundle = [];

      document.documentElement.dispatchEvent(
        new CustomEvent(
          'cart:prepare-bundled-sections',
          {
            bubbles: true,

            detail: {
              sections:
                sectionsToBundle
            }
          }
        )
      );

      /*
       * Shopify bundle request
       */
      const response =
        await fetch(
          `${Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json',

              'X-Requested-With':
                'XMLHttpRequest'
            },

            body: JSON.stringify({
              items,

              sections:
                sectionsToBundle.join(','),

              sections_url:
                `${Shopify.routes.root}variants/${mainVariantId}`
            })
          }
        );

      const result =
        await response.json();

      console.log(
        '[Ghostly Bundle] Shopify response:',
        result
      );

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Unable to add bundle.'
        );
      }

      /*
       * Full cart page mode
       */
      if (
        window.themeVariables?.settings?.cartType === 'page' ||
        window.themeVariables?.settings?.pageType === 'cart'
      ) {
        window.location.href =
          `${Shopify.routes.root}cart`;

        return;
      }

      /*
       * Get updated cart
       */
      const cart =
        await (
          await fetch(
            `${Shopify.routes.root}cart.js`
          )
        ).json();

      cart.sections =
        result.sections;

      /*
       * Match Ghostly Engines'
       * normal ProductForm success event
       */
      form.dispatchEvent(
        new CustomEvent(
          'variant:add',
          {
            bubbles: true,

            detail: {
              items:
                result.items ||
                [result],

              cart,

              onSuccessDo:
                formData.get(
                  'on_success'
                )
            }
          }
        )
      );

      /*
       * Update native Ghostly Engines cart
       */
      document.documentElement.dispatchEvent(
        new CustomEvent(
          'cart:change',
          {
            bubbles: true,

            detail: {
              baseEvent:
                'variant:add',

              onSuccessDo:
                formData.get(
                  'on_success'
                ),

              cart
            }
          }
        )
      );

    } catch (error) {
      console.error(
        '[Ghostly Bundle Error]',
        error
      );

      form.dispatchEvent(
        new CustomEvent(
          'cart:error',
          {
            bubbles: true,

            detail: {
              error:
                error.message
            }
          }
        )
      );

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh'
        )
      );

    } finally {
      submitButtons.forEach(button => {
        button.removeAttribute(
          'aria-busy'
        );
      });

      document.documentElement.dispatchEvent(
        new CustomEvent(
          'theme:loading:end',
          {
            bubbles: true
          }
        )
      );
    }
  }

  /*
   * --------------------------------------------------------
   * ADD TO CART SUBMIT
   * --------------------------------------------------------
   *
   * Capture phase ensures this runs
   * before Ghostly Engines' native
   * ProductForm listener.
   */
  document.addEventListener(
    'submit',

    event => {
      const form =
        event.target;

      if (
        !(
          form instanceof
          HTMLFormElement
        )
      ) {
        return;
      }

      if (
        !form.closest(
          'product-form'
        )
      ) {
        return;
      }

      /*
       * IMPORTANT:
       * Do NOT use form.id here.
       *
       * The form contains an input
       * name="id", which shadows
       * the native form.id property.
       */
      const formId =
        form.getAttribute('id');

      if (!formId) {
        return;
      }

      if (
        !getBundleDetails(
          formId
        ).length
      ) {
        return;
      }

      addBundle(
        form,
        event
      );
    },

    true
  );

  /*
   * --------------------------------------------------------
   * BUNDLE VARIANT SELECTOR
   * --------------------------------------------------------
   */
  document.addEventListener(
    'change',

    event => {
      const select =
        event.target;

      if (
        !(
          select instanceof
          HTMLSelectElement
        )
      ) {
        return;
      }

      const picker =
        select.closest(
          '[is="product-bundle-picker"]'
        );

      if (!picker) {
        return;
      }

      const checkbox =
        picker.querySelector(
          'input[name="bundles"]'
        );

      const option =
        select.selectedOptions?.[0];

      if (
        !checkbox ||
        !option
      ) {
        return;
      }

      /*
       * Update selected variant ID
       */
      checkbox.value =
        option.value;

      /*
       * Update min quantity
       */
      if (
        option.dataset.min
      ) {
        checkbox.dataset.min =
          option.dataset.min;
      }

      /*
       * Update price data
       */
      if (
        option.dataset.price
      ) {
        checkbox.dataset.price =
          option.dataset.price;
      }

      /*
       * Update image
       */
      const image =
        picker.querySelector(
          'picture img'
        );

      if (
        image &&
        option.dataset.imgSrc
      ) {
        image.src =
          option.dataset.imgSrc;

        if (
          option.dataset.imgSrcset
        ) {
          image.srcset =
            option.dataset.imgSrcset;
        }
      }
    }
  );
})();